import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-background text-center text-foreground" aria-label="Limited time offer" data-id="element-236" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgba(0,200,248,0.8)]" aria-hidden="true" data-id="element-237" data-mp="36bimxjk5vlee" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-238" data-mp="31hxyai4gk3rv">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-primary" data-id="element-239" data-mp="3g7lyfg0wkwe0">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="3b7zc8h33k5t2" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-241" data-mp="3p7s7mppkja7d" />
        <p className="mt-7 font-bold text-foreground" data-id="element-242" data-mp="3p6piam7w9ftk">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgba(0,200,248,0.8)]" aria-hidden="true" data-id="element-243" data-mp="1uuixcvp77ko2" />
    </section>;
}